import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'autoInputWidth' })
export class AutoInputWidth implements PipeTransform {
  transform(value: string | number, em: number = 0.6): number {
    return (value?.toString()?.length || 0) * em + 1;
  }
}
